import React from 'react';
import './DunsAbbr.css';
export var DunsAbbrText = 'D-U-N-S®';
export var DunsNumberAbbrText = 'D-U-N-S® Number';

var DunsAbbr = function DunsAbbr() {
  return React.createElement('span', {
    className: 'DunsAbbr'
  }, 'D-U-N-S', React.createElement('sup', null, '\xAE'));
};

export var DunsNumberAbbr = function DunsNumberAbbr() {
  return React.createElement('span', {
    className: 'DunsAbbr'
  }, 'D-U-N-S', React.createElement('sup', null, '\xAE'), ' Number');
};
export default DunsAbbr;